import { z } from "zod";

export const getPersonioAttendancesQuerySchema = z.object({
	limit: z.number().optional(),
});

export type PersonioGetAttendancesQuery = z.infer<typeof getPersonioAttendancesQuerySchema>;
